module.exports = __webpack_public_path__ + "img/estrela.cab99c2d.svg";